import { render } from "./BpmnViewer.vue?vue&type=template&id=081c50a6&scoped=true"
import script from "./BpmnViewer.vue?vue&type=script&lang=js"
export * from "./BpmnViewer.vue?vue&type=script&lang=js"

import "./BpmnViewer.vue?vue&type=style&index=0&id=081c50a6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-081c50a6"]])

export default __exports__